import React from "react";
import MeBusinessLogo from "src/img/new/me_business_logo.png";
import {
    ConnectionDot,
    LiveCallHeaderBar,
    LiveCallIdentity,
    LiveCallLogo,
    LiveCallMeta,
    LiveCallSubtitle,
    LiveCallTitle,
    LiveCallTitleGroup
} from "src/scenes/Chat/components/ChatCallPanel.styled";

const formatDuration = (startedAt = 0, now = Date.now()) => {
    if (!startedAt) {
        return "00:00";
    }

    const totalSeconds = Math.max(0, Math.floor((now - startedAt) / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};

const LiveCallHeader = ({
    avatarInitials,
    avatarUrl,
    callState,
    conversationName,
    isGroupCall,
    participantCount,
    now
}) => {
    const isConnected = callState?.status === "on_call";
    const showBrandFallback = isGroupCall && !avatarUrl;

    return (
        <LiveCallHeaderBar>
            <LiveCallIdentity>
                <LiveCallLogo
                    role="img"
                    aria-label={avatarUrl || avatarInitials ? `${conversationName} profile` : "Me Business"}
                    $brand={showBrandFallback}
                    $hasImage={Boolean(avatarUrl)}
                >
                    {avatarUrl ? (
                        <img src={avatarUrl} alt="" />
                    ) : showBrandFallback ? (
                        <img src={MeBusinessLogo} alt="" />
                    ) : avatarInitials}
                </LiveCallLogo>
                <LiveCallTitleGroup>
                    <LiveCallTitle>{conversationName || "Me Business call"}</LiveCallTitle>
                    <LiveCallSubtitle>
                        {participantCount} {participantCount === 1 ? "participant" : "participants"}
                    </LiveCallSubtitle>
                </LiveCallTitleGroup>
            </LiveCallIdentity>
            <LiveCallMeta>
                <ConnectionDot $connected={isConnected} />
                <span>{isConnected ? "Connected" : "Connecting"}</span>
                <span>{formatDuration(callState?.startedAt, now)}</span>
            </LiveCallMeta>
        </LiveCallHeaderBar>
    );
};

export default LiveCallHeader;
